// Module
var code = " <gb-button icon=\"add\" ng-click=\"$ctrl.addWidget()\"> <span translate=\"ADD_RAFFLE_WINNERS_WIDGET_BUTTON\"></span> </gb-button> <gb-edit-raffle-winners-widget widget=\"$ctrl.widget\"></gb-edit-raffle-winners-widget> ";
// Exports
export default code;